import React from 'react';
import _ from 'lodash';

import {
  baseTypes,
  pagination,
  useLoading
} from 'modules';

import { useAccessPassesTabPaneQuery } from 'generated/graphql';
import moment from 'moment';



export interface IRow {
  id: string;
  email: string;
  note: string;
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export interface IData {
  page: baseTypes.IPage<IRow>;
}

export function useQuery(paginationInput: pagination.IListPagePaginationParams) {
  const tuple = useAccessPassesTabPaneQuery({
    variables: { paginationInput }
  });
  const loading = useLoading([tuple]);



  return React.useMemo(() => {
    const data: IData = {
      page: {
        pages: tuple.data?.accessPasses.pageInfo.pages ?? [],
        totalRows: tuple.data?.accessPasses.pageInfo.totalRows ?? 0,
        nodes: _.map(tuple.data?.accessPasses.nodes ?? [], (node): IRow => ({
          id: node.id,
          email: node.email,
          note: node.note,
          startDate: moment(node.startDate),
          endDate: moment(node.endDate)
        }))
      }
    };

    return {
      ...tuple,
      data,
      loading,
      fnRefetch: () => tuple.refetch()
    };
  }, [loading, tuple]);
}
